/**
 * Created by RKL on 07/09/2015.
 */
define('superAdminMbAnaDetailsController',[
  'module',
  'underscore',
  'app',
  'bootbox',
  'superAdminMbAnaDetailsView',
  'emptyView',
  'mbAnaDetailTabController',
  'superAdminMbAnaDetailsController',
  'rolesMixin',
  'settings',
  'superAdminMbAnasTabs',
  'entities/mbanas'
], function(
  module,
  _,
  App,
  bootbox,
  View,
  EmptyView,
  mbAnaDetailTabController
) {
  'use strict';

  var MbAnasDetailsController = {
    fetchMbAna: function(data) {
      var that = this,
          emptyView = new EmptyView(),
          contentRegion = App.regions.getRegion('main').currentView.getRegion('content');

      contentRegion.show(emptyView);

      this.data = data;
      if (this.model && this.model.get('secId') === data.secId) {
        this.showMbAna(data);
      } else {
        this.model = App.request('mbana:model', {secId: data.secId});
        this.model.fetch().done(function() {
          if (contentRegion) {
            that.showMbAna(data);
          }
        });
      }
    },

    showMbAna: function(data) {
      var view = new View({model: this.model, data: data});

      this.view = view;
      data.model = this.model;

      App.regions.getRegion('main').currentView.getRegion('content').show(view);

      this.displayTabs(data);

      view.listenTo(view, 'click:tab', _.bind(this.onTabClick, this));
      view.listenTo(App, 'mbana:header:rerender', _.bind(this.onHeaderChange, this));
    },

    onHeaderChange: function (mbana) {
      this.view.onHeaderChange(mbana);
    },

    displayTabs: function(data) {
      mbAnaDetailTabController.showTab(data);
      data.model = this.model;
      this.tab = data.tab;
    },

    onTabClick: function(tab) {
      if (this.data.tab !== tab || this.data.secId) {
        this.data.tab = tab;
        this.data.secId = null;

        this.displayTabs(this.data);
        App.navigate('superAdmin/mbanas/' + this.model.get('secId') + '/' + tab.name);
      }
    }
  };

  module.exports = MbAnasDetailsController;
});
